module.exports = __webpack_public_path__ + "img/couponBanner.388da2da.png";